import { create } from 'zustand';

import { UserBySiteKeyDto, UserDto } from '@pimm/services/lib/sms-tenants';

interface AUsersWithSiteState {
  users?: UserBySiteKeyDto[];
}

type UsersWithSiteKeys = AUsersWithSiteState & {
  setUsers: (_users?: UserBySiteKeyDto[]) => void;
  clear: () => void;
};

export const useUsersWithSiteKeys = create<UsersWithSiteKeys>(set => ({
  setUsers: _users => set({ users: _users }),
  clear: () => set({ users: [] }),
}));
